import { useSelector } from 'react-redux';
import { getDeepReservationsByProductType } from 'utils/helpers';
import { getCurrentBooking } from 'redux/selectors/current_booking';
import {
  AccommodationView,
  AccommodationViewNoDate,
} from './accommodation_view';

const Accommodation = () => {
  const currentBooking = useSelector(getCurrentBooking);
  const accommodations = getDeepReservationsByProductType(
    'accommodation',
    currentBooking
  );

  if (!accommodations || accommodations.length === 0) {
    return <AccommodationViewNoDate />;
  }

  return <AccommodationView />;
};

export default Accommodation;
